import { Tracked, TrackedValue } from '@kibsi/art-types'

export function normalizeTracked(value?: unknown): Tracked | undefined {
    if (typeof value === 'object') {
        if (value === null || Array.isArray(value)) {
            return undefined
        }

        const tracked: Tracked = {}
        const obj = value as any

        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        if (isOldTracked(obj)) {
            if (obj.current !== undefined) {
                tracked.current = { value: obj.current, time: obj.lastTime as number }
            }

            if (obj.first !== undefined) {
                tracked.first = { value: obj.first, time: obj.firstTime as number }
            }

            if (obj.last !== undefined) {
                tracked.last = { value: obj.last, time: obj.lastTime as number }
            }
        } else {
            tracked.current = obj.current as TrackedValue
            tracked.first = obj.first as TrackedValue
            tracked.last = obj.last as TrackedValue
            tracked.previous = obj.previous as TrackedValue
        }

        return tracked
    }

    return undefined
}

interface OldTracked {
    current?: unknown
    first?: unknown
    firstTime?: number
    last?: unknown
    lastTime?: number
    min?: number
    max?: number
}

// eslint-disable-next-line @typescript-eslint/ban-types
function isOldTracked(value: {}): value is OldTracked {
    return 'firstTime' in value || 'lastTime' in value
}
